import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs.js";
import { TenantMembers } from "./tenant-members.js";
import { TenantRoles } from "./tenant-roles.js";
import { TenantSettings } from "./tenant-settings.js";

export interface TenantDetailTabsProps {
  organizationId: string;
  canManage?: boolean;
  canDelete?: boolean;
  /** Superadmin: add members by picking from the system-wide user list. */
  userPicker?: boolean;
  onDeleted?: () => void;
  /** Called with the new uuid after a successful id change. */
  onIdChanged?: (newId: string) => void;
}

export const TenantDetailTabs = ({
  organizationId,
  canManage = false,
  canDelete = false,
  userPicker = false,
  onDeleted,
  onIdChanged,
}: TenantDetailTabsProps) => (
  <Tabs defaultValue="members">
    <TabsList>
      <TabsTrigger value="members">Members</TabsTrigger>
      <TabsTrigger value="roles">Roles</TabsTrigger>
      <TabsTrigger value="settings">Settings</TabsTrigger>
    </TabsList>
    <TabsContent value="members" className="mt-4">
      <TenantMembers
        organizationId={organizationId}
        canManage={canManage}
        userPicker={userPicker}
      />
    </TabsContent>
    <TabsContent value="roles" className="mt-4">
      <TenantRoles organizationId={organizationId} canManage={canManage} />
    </TabsContent>
    <TabsContent value="settings" className="mt-4">
      <TenantSettings
        organizationId={organizationId}
        canManage={canManage}
        canDelete={canDelete}
        onDeleted={onDeleted}
        onIdChanged={onIdChanged}
      />
    </TabsContent>
  </Tabs>
);
